import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BreadCumb, DataTables, NavBar, TimeOut } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient, } from '../../libs/apiClient';
import config from '../../config';
import moment from "moment";
import { PriceListsModel } from '../../components/NewOrder';

let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Nombre de la lista de precios", value: true }, //0
    { title: "Factores", value: true }, //1
    { title: "Lista de precios base por defecto", value: true }, //2
    { title: "Factor por defecto", value: true }, //3
    { title: "Método de redondeo", value: true }, //4
    { title: "Grupo de autorización", value: true }, //5
    { title: "Estatus", value: true }, //6
    { title: "Moneda primaria", value: true }, //7
]

class PriceListsView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        }
        this.inputRefs = {};

    }

    async componentDidMount() {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liFactura");
        let today = moment(new Date()).format('YYYYMMDD');

        let date = {
            dateInit: today,
            dateFinal: today,
        }

        await this.callDocumentsListService(date);
    }

    callDocumentsListService = async newDate => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        console.log('con<-newDate', newDate);
        const data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            switch1: newDate.docStatus || '---',
            groupCodeValue: newDate.groupCodeValue || '---',
            docSubType: "--",
            table: "OPLN",
            docNumSearch: newDate.docNumSearch ? newDate.docNumSearch === '' ? '--' : newDate.docNumSearch : '--',
            searchSerieName: newDate.searchSerieName ? newDate.searchSerieName === '' ? '--' : newDate.searchSerieName : '--'
        };

        enableSpinner(true);
        const invoiceListResponse = await apiClient.getDocumentsListInvoice(data);
        console.log('con<-invoiceListResponse', invoiceListResponse);
        enableSpinner(false);

        if (invoiceListResponse.status === SERVICE_RESPONSE.SUCCESS) {

            if (invoiceListResponse.data.length === 0) {
                showAlert({
                    type: 'info',
                    timeOut: 5000,
                    message: "No se encontraron resultados correspondientes a la búsqueda."
                });

                this.setState({
                    data: [],
                });
                return;
            }

            let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

            if (!user) {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
                });

                this.setState({
                    data: [],
                });
                return;
            }

            this.setState({
                data: invoiceListResponse.data || [],
            });
            return;
        } else {
            this.setState({
                data: [],
            });
        }
    }

    searchDocuments = async date => {
        await this.callDocumentsListService(date);
    };

    addLine = async (info) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { data } = this.state;
        enableSpinner(true);
        let dataaux = data;
        await this.setState({
            data: [],
        });
        // if (info) {
        console.log('con<-----------ENTRE--------',);
        let model = {
            isNew: true,
            AddCurr1: "MXP",
            AddCurr2: "MXP",
            BASE_NUM: 1,
            CreateDate: null,
            DataSource: "N",
            ExtAmount: "0.000000",
            Factor: "1.000000",
            GroupCode: 1,
            IsGrossPrc: "N",
            ListName: "",
            ListNum: 46,
            LogInstanc: 0,
            PrimCurr: "MXP",
            RndFrmtDec: null,
            RndFrmtInt: null,
            RoundRule: "R",
            RoundSys: 0,
            SPPCounter: 76,
            U_Plaza: null,
            U_Tipo: null,
            UpdateDate: "2020-11-02 00:00:00.000000000",
            UserSign: 1,
            UserSign2: 1,
            ValidFor: "Y",
            ValidFrom: null,
            ValidTo: null,
        };
        dataaux.push(model);
        showAlert({
            type: 'success',
            timeOut: 5000,
            message: "Se agrego correctamente la nueva linea."
        });
        console.log('con<-data', data);
        await this.setState({
            data: dataaux,
        });
        enableSpinner(false);
        // }
    };

    // Change_ListName = async (event, index) => {
    //     const { data } = this.state;
    //     const newValue = event.nativeEvent.target.value;
    //     let dataaux = data;
    //     await this.setState({
    //         data: [],
    //     });
    //     console.log('con<newValue', newValue, 'index', index, 'dataaux', dataaux[index].ListName);
    //     if (dataaux[index].ListName !== newValue) {
    //         dataaux[index].isUpdate = dataaux[index].isNew ? false : true;
    //         dataaux[index].ListName = newValue;
    //         await this.setState({
    //             data: dataaux,
    //         });
    //         // this.refreshModel(data);
    //     }else {
    //         dataaux[index].isUpdate = false;
    //         await this.setState({
    //             data: dataaux,
    //         });
    //     }
    // };

    Change_ListName = (event, index, ref, property) => {
        console.log('con<-----------property--------', property);
        console.log('con<-----------ref--------', ref);
        const { data } = this.state;
        const newValue = event.target.value; // más directo que nativeEvent  
        console.log('con<-----------newValue--------', newValue);

        // const newData = [...data]; // clona para no mutar el original directamente
        // if (newData[index].ListName !== newValue) {
        //     newData[index].isUpdate = !newData[index].isNew;
        //     newData[index].ListName = newValue;
        // } else {
        //     newData[index].isUpdate = false;
        // }

        // this.setState({ data: newData });

        this.setState((prevState) => ({
            data: prevState.data.map((list, idx) =>
                idx === index ? { ...list, [property]: newValue } : list
            )
        }), () => {
            if (this.inputRefs[ref]) {
                this.inputRefs[ref].focus();
            }
        });
    };

    DetailsPriceList = async (ListNum) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props

        enableSpinner(true);
        const details = await apiClient.getDetailsPriceList(ListNum);
        enableSpinner(false);

        if (details.status === SERVICE_RESPONSE.SUCCESS) {
            let newOrderModel = new PriceListsModel();
            newOrderModel = this.fillPriceListModel(newOrderModel, details?.data ?? {});

            return newOrderModel;
        } else {
            showAlert({ type: 'error', message: details.message })
            return false
        }
    };

    fillPriceListModel = (model, data) => {
        model.ListNum = data?.ListNum || '';
        model.ListName = data?.ListName || '';
        model.BASE_NUM = data?.BASE_NUM || '';
        model.Factor = Number(data?.Factor || 1);
        model.FactorView = Number(data?.Factor || 1).toFixed(4);
        model.RoundSys = (data?.RoundSys !== undefined && data?.RoundSys !== null) ? data.RoundSys.toString() : '0';
        model.RoundRule = data?.RoundRule || '';
        model.GroupCode = data?.GroupCode || '';
        model.ValidFor = data?.ValidFor || '';
        model.PrimCurr = data?.PrimCurr || '';

        return model;
    };

    render() {
        const { headers, data, _user } = this.state;
        console.log('con<-----------this.inputRefs', this.inputRefs);
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'LISTA DE PRECIOS'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>

                    <h2 className="md-display-1">
                        <span id="linkOrdProv" className="text-muted">
                            &nbsp;LISTA DE PRECIOS
                        </span>
                    </h2>
                    <DataTables
                        headers={headers}
                        view={"priceLists"}
                        data={data}
                        search={this.searchDocuments}
                        addLine={this.addLine}
                        Change_ListName={this.Change_ListName}
                        refs={this.inputRefs}
                        openDetails={this.DetailsPriceList}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PriceListsView);


